import { RouteRecordRaw } from 'vue-router';

let routes: RouteRecordRaw[] = [
    {
        path: '/printTemplates',
        name: 'printTemplates',
        meta: { sideMenuLabel: "Template", sideMenuIcon: "icon-file-earmark" },
        component: () => import("./views/printTemplates.vue")
    },
    {
        path: '/printTemplates/:identifier',
        name: 'printTemplatesDetail',
        meta: { sideMenuLabel: "Template" },
        component: () => import("./views/printTemplatesDetail.vue")
    }
];

export default routes;